import "../styles/ranking.css";
import { API_CONFIG } from "../config/api";
import { generateAuthToken, generateURN } from "../components/hmac";
import { useEffect, useState, useCallback } from "react";
import { useAuth } from "../context/AuthContext";



const Ranking = () => {

  const [rankData,setRankData]=useState([]);
  const [loading, setLoading] = useState(false);
  const [page,setPage]=useState(1);
  const {profileUser} = useAuth();
  const [rank,setRank]=useState(0);
  const [user,setUser]=useState({});
  const [totalPlayers,setTotal]=useState(0);
  const totalPages = Math.ceil(totalPlayers / 10);
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  const fetchRankings = useCallback(async () => {
    try {
      setLoading(true)

      const {host,userRanking,basic}=API_CONFIG;
      const urn=generateURN();
      const authToken=generateAuthToken(urn);

      const res = await fetch(
        `https://${host}${userRanking.path}?page=${page}&user=${profileUser.userName}`,
        {
          method:userRanking.method,
          credentials: "include",
          headers:{
             Authorization:`Basic ${basic.BASIC_AUTH_CWUSER}`,
             urn:urn,
             authToken:authToken,
           } 
        }
      );
  
      const json = await res.json();
      const data = json?.apiResponseData?.responseData?.userRanking?.result || [];
      const otherData=json.apiResponseData.responseData.userRanking;
      setRank(otherData.currentUserRank);
      setUser(otherData.currentUser);
      setTotal(otherData.total);
      setRankData(data);
    } catch (err) {
        console.log("API ERROR",err);
    }finally{
        setLoading(false)
    }
  }, [page, profileUser.userName]);

  useEffect(() => {
    fetchRankings();
  }, [fetchRankings]);

  const getRankIcon = (index) => {
    if (index === 0) return "🥇";
    if (index === 1) return "🥈";
    if (index === 2) return "🥉";
    return index + 1;
  };

  return (
    <div className="ranking-page">
      <div className="ranking-header">
        <h1 className="ranking-title">Rankings</h1>

        <div className="ranking-btn-row">
            <button className="ranking-refresh-btn" onClick={fetchRankings}>
            Refresh
            </button>
        </div>
      </div>
      
      {loading ? (
        <p className="ranking-status">Loading rankings...</p>
      ) : rankData.length === 0 ? (
        <p className="ranking-status">No ranking data found.</p>
      ) : (
        <div className="ranking-table-wrapper">
          <table className="ranking-table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Username</th>
                <th>Rating</th>
                <th>Gold Points</th>
              </tr>
            </thead>

            <tbody>
              <tr  className="current-user">
                  <td className="rank-col">{getRankIcon(rank)}</td>
                  <td className="username-col">{user.userName}</td>
                  <td>{user?.rating ?? "-"}</td>
                  <td>{user?.goldPoints ?? 0}</td>
              </tr>
              {rankData.map((user, index) => (
                <tr key={index} className={index < 3 ? `top-${index + 1}` : ""}>
                  <td className="rank-col">{getRankIcon(index+(page-1)*10)}</td>
                  <td className="username-col">{user?.userName || "Unknown"}</td>
                  <td>{user?.rating ?? "-"}</td>
                  <td>{user?.goldPoints ?? 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div className="ranking-btn-row">
        <button className="ranking-refresh-btn"
          onClick={()=>{setPage(prev=>prev-1)}}
          disabled={page===1}>
          ⬅ Back
        </button>

          <div className="page-number-container">
    {pageNumbers.map(num => (
      <button
        key={num}
        className={`page-number-btn ${page === num ? "active" : ""}`}
        onClick={() => setPage(num)}
      >
        {num}
      </button>
    ))}
  </div>


        <button className="ranking-refresh-btn"
          onClick={()=>{setPage(prev=>prev+1)}}
          disabled={rankData.length!==10} >
          Next ➡
        </button>
      </div>
    </div>
  );
};

export default Ranking;
